import React from 'react';
export function CTASection() {
  return <section id="pricing" className="w-full bg-gradient-to-br from-[#1a1f2e] to-[#0f1419] py-16 md:py-24 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto text-center" data-id="element-2">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#e8edf4] mb-8 leading-tight" data-id="element-3">
          Si hoy te acostaras… y en vez de pelear con tu cabeza tuvieras un plan
          claro de 10 minutos…
        </h2>

        <p className="text-xl md:text-2xl text-[#d1d9e6] mb-12 leading-relaxed" data-id="element-4">
          ¿cuánto valdría para ti no sentirte sola en esa oscuridad?
        </p>

        <div className="mb-8" data-id="element-5">
          <p className="text-[#a8b5d1] text-lg mb-4 font-medium" data-id="element-6">
            Precio especial de lanzamiento
          </p>

          <div className="flex items-center justify-center gap-4 mb-4" data-id="element-7">
            <span className="text-2xl md:text-3xl text-[#b8c5d6] line-through" data-id="element-8">
              $19.00
            </span>
            <span className="bg-[#e76f51] text-white text-sm md:text-base font-bold px-4 py-2 rounded-full shadow-lg shadow-[#e76f51]/20" data-id="element-9">
              66% DE DESCUENTO
            </span>
          </div>

          <div className="text-6xl md:text-7xl font-bold text-[#e76f51] mb-3" data-id="element-10">
            $6.39
          </div>

          <p className="text-[#b8c5d6] text-sm" data-id="element-11">
            Acceso inmediato al protocolo completo
          </p>
        </div>

        <button onClick={() => window.location.href = 'https://millionandmillions.com/cart/42466337620062:1'} className="bg-[#e76f51] hover:bg-[#d65d3f] text-white font-semibold px-10 py-5 rounded-lg text-xl transition-all duration-200 shadow-2xl shadow-[#e76f51]/30 hover:shadow-[#e76f51]/40 focus:outline-none focus:ring-4 focus:ring-[#a8b5d1]/30" aria-label="Descarga APAGA LA CABEZA EN 10 MIN" data-id="element-12">
          Descarga APAGA LA CABEZA EN 10 MIN
        </button>
      </div>
    </section>;
}